import {Translations} from './message.def';

export const ja: Translations = {
  privacy: {
    title: 'プライバシーポリシー',
    acquisition: {
      title: '■ 利用者情報の取得',
      text: '本アプリでは、ログ機能を実現のために、利用者の位置とフィットネス活動情報の取得が必要となります。',
    },
    use: {
      title: '■ 利用者情報の利用',
      text: '本アプリでは、ログの確認機能に、取得した利用者の位置とフィットネス活動情報を利用しております。',
    },
    disclosure: {
      title: '■ 利用者情報の第三者提供',
      text: '本アプリが利用者の個人情報を第三者へ提供することはありません。',
    },
    tools: {
      title: '■ 使用ツール',
      text: '本アプリでは、広告配信ツールとしてAppLovin (AppLovin Corporation) を使用しており、AppLovin が利用者の情報を自動取得する場合があります。取得する情報、利用目的、第三者への提供等につきましては、広告配信事業者のアプリケーション・プライバシーポリシーよりご確認ください。\n（本アプリは、AppLovinに利用者の情報を収集しないように設定しております)',
    },
    contact: {
      title: '■ お問い合わせ先',
      text: '何かご不明な点がございましたらお問い合わせください。\ndev.logme@gmail.com',
    },
  },
};
